import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-edit",
  "use": "n-icon-edit-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"n-icon-edit\"><path fill=\"currentColor\" d=\"M13.167 3.402 10.883 1.12a1.667 1.667 0 0 0-2.216-.058l-7.5 7.5c-.27.271-.437.627-.475 1.008l-.359 3.475a.833.833 0 0 0 .834.908h.075l3.475-.316c.38-.038.736-.206 1.008-.475l7.5-7.5a1.6 1.6 0 0 0-.058-2.259Zm-8.6 8.567-2.5.233.225-2.5L7 5.052l2.25 2.25-4.683 4.667Zm5.766-5.783L8.1 3.952l1.625-1.666L12 4.56l-1.667 1.625Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol